import imagesLoaded from "imagesloaded";
import { gsap } from "gsap";

const delay = (n) => {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
};

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const getCurrentBaseUrl = () => {
  const baseElement = document.querySelector("base");
  if (baseElement) {
    return baseElement.href;
  } else {
    // If no base element is found, use the current window location
    return window.location.origin;
  }
};

const preloadImages = (selector = "img") => {
  return new Promise((resolve) => {
    let imgLoad = imagesLoaded(
      gsap.utils.toArray(selector),
      { background: true },
      resolve
    );
    imgLoad.on("progress", function (instance, image) {
      let result = image.isLoaded ? "loaded" : "broken";
    });
  });
};

const shuffler = (parent, children) => {
  while (children.length) {
    parent.append(
      children.splice(Math.floor(Math.random() * children.length), 1)[0]
    );
  }
};

const safariBackdropBlurFix = () => {
  if (/apple/i.test(navigator.vendor)) {
    document
      .querySelectorAll([".glass-white", ".glass-black"])
      .forEach((el, i) => {
        el.style.setProperty("backdrop-filter", "blur(16px)");
        el.style.setProperty("-webkit-backdrop-filter", "blur(16px)");
      });
  }
};

const findIndex = (arr, val) => {
  const found = arr.findIndex((subArr) => subArr.includes(val));
  return found !== -1 ? found : -1;
};

const stripUnderscoresAndReplaceWithSpaces = (str) => {
  return str.replace(/_/g, " ");
};

export {
  delay,
  debounce,
  shuffler,
  findIndex,
  getCurrentBaseUrl,
  safariBackdropBlurFix,
  preloadImages,
  stripUnderscoresAndReplaceWithSpaces,
};
